export enum DayWofWeek {
  monday = 0,
  tuesday = 1,
  wednesday = 2,
  thursday = 3,
  friday = 4,
  saturday = 5,
  sunday = 6,
}

export interface DaysOfWeekResource {
  mo: boolean
  tu: boolean
  we: boolean
  th: boolean
  fr: boolean
  sa: boolean
  su: boolean
}

export enum PeriodChargeType {
  charge = 0,
  discharge = 1,
}

export interface EmsTimeRange {
  emsIdlePeriodHour: number
  emsIdlePeriodMinute: number
}

/**
 * IdlePeriod API schema for the current (2023) settings
 */
export interface EmsPeriodApiResource {
  emsPeriodType: PeriodChargeType
  emsPeriodWeekdays: DaysOfWeekResource
  emsPeriodActive: boolean
  emsPeriodStart: number
  emsPeriodStop: number
  emsPeriodName: string
}

/**
 * IdlePeriod schema for the legacy api settings
 */
export interface EmsPeriodLegacyApiResource {
  emsIdlePeriodType: PeriodChargeType
  emsIdlePeriodDay: DayWofWeek
  emsIdlePeriodActive: boolean
  emsIdlePeriodStart: EmsTimeRange
  emsIdlePeriodEnd: EmsTimeRange
}

export interface EmsSysSpec {
  maxChargePower: number
}
